(function () {
    'use strict';
    angular.module('doclr.keycloak', []);
})();
